import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { InfoPageTitle } from 'views/common/components';

const StyledBox = styled(Box)(({ theme }) => ({
  background: theme.palette.common.white,
  '& .RTACTabsBarWrapper': {
    position: 'relative',
    '&::before': {
      content: '""',
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
      position: 'absolute',
      width: '100%',
      bottom: 0,
    },
  },
}));
export const StyledInfoPageTitle = styled(InfoPageTitle)(({ theme }) => ({
  '& .reservationFloatingButton': {
    [theme.breakpoints.up('lg')]: {
      padding: 0,
    },
  },
}));

export default StyledBox;
